









































import Vue from 'vue';
import { FeedbackClient, Feedback } from '@/assets/src/clients/feedback_client';
import { SearchParameter } from '@/assets/src/search_parameter';
import { toNiceDate } from '@/assets/src/utils/date';
import ROUTE_NAMES from '@/assets/src/routes';

export default Vue.extend({
  name: 'ListFeedback',

  methods: {
    toNiceDate,

    async listFeedback() {
      this.feedbacks = await this.feedbackClient.listFeedback([new SearchParameter('admin_has_processed', false)]);
    },

    async completeFeedback(feedback: Feedback) {
      await this.feedbackClient.updateFeedback(feedback.id, true);
      await this.listFeedback();
    },
  },

  mounted() {
    this.listFeedback();
  },

  data() {
    return {
      feedbacks: [] as Feedback[],
      feedbackClient: new FeedbackClient(),
    };
  },

  routeNames: ROUTE_NAMES,
});
